const roleHelper = require('../../../../../src/graphql/schema/queries/helpers/role')

;(function () {
  'use strict'

  angular
    .module('contrast.rules.exclusions')
    .controller(
      'ExclusionsCtrl',
      function (
        $scope,
        $timeout,
        $translate,
        logger,
        dialogs,
        csTemplates,
        ErrorService,
        RuleExclusionService,
        ApplicationFactory,
        ProtectionRulesFactory,
        permissions,
        FeaturesService
      ) {
        'ngInject'

        var _searchKeywords = ''
        var numPerLoad = 15
        var deleteExclusionTemplateUrl =
          'views/rules/exclusions/template/delete.tpl.html'

        angular.extend($scope, {
          data: {
            total: 0,
            count: 0,
            exclusions: []
          },
          model: {
            searchKeywords: searchKeywords,
            busy: true,
            row: 'name'
          },
          loadPromise: undefined
        })

        angular.extend($scope, {
          order: order,
          loadByScroll: loadByScroll,
          deleteExclusion: deleteExclusion,
          changeDefend: changeDefend,
          checkPermission: checkPermission,
          checkAppRole: checkAppRole,
          changeAssessment: changeAssessment,
          getAppRole: getAppRole,
          link_mergeApplications: $translate.instant('link_mergeApplications')
        })

        function init() {
          loadExclusions(0, numPerLoad, $scope.model.row)
        }

        function searchKeywords(newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }
          $scope.model.busy = true
          clearExclusions()
          loadExclusions(0, numPerLoad, $scope.model.row)

          return _searchKeywords
        }

        function clearExclusions() {
          $scope.data.exclusions = []
          $scope.data.count = 0
        }

        function loadExclusions(offset, limit, sort) {
          var expand = 'roles'
          $scope.loadPromise = ProtectionRulesFactory.getAllExclusions(
            _searchKeywords,
            limit,
            offset,
            sort,
            expand
          )
          $scope.loadPromise.then(
            function (response) {
              $scope.data.total = response.data.total
              $scope.data.count = response.data.count

              _.each(
                response.data.exceptions,
                RuleExclusionService.addSwitchProperties
              )

              $scope.data.exclusions = $scope.data.exclusions.concat(
                response.data.exceptions
              )

              $scope.model.busy = false
              $timeout(function () {
                $scope.$emit('triggerScrollCheck')
              })
            },
            function (response) {
              $scope.model.busy = false
              ErrorService.processError(response)
            }
          )
        }

        function loadByScroll() {
          if (
            $scope.data.count == $scope.data.exclusions.length ||
            $scope.data.total == 0
          ) {
            return
          }
          $scope.model.busy = true
          loadExclusions(
            $scope.data.exclusions.length,
            numPerLoad,
            $scope.model.row
          )
        }

        function order(rowName) {
          if ($scope.model.row === rowName) {
            return
          }
          $scope.model.row = rowName
          $scope.model.busy = true
          clearExclusions()
          loadExclusions(0, numPerLoad, $scope.model.row)
        }

        function deleteExclusion(exclusion) {
          return csTemplates
            .loadAndInterpolate(deleteExclusionTemplateUrl, {
              exclusionName: exclusion.name
            })
            .then(
              function (interpolatedStr) {
                _deleteExclusion(interpolatedStr, exclusion)
              },
              function () {
                logger.logError('Unable to load remove dialog')
              }
            )
        }

        function _deleteExclusion(msg, exclusion) {
          var transl = {
            action_deleteExclusion: $translate.instant(
              'action_deleteExclusion'
            ),
            action_delete: $translate.instant('action_delete'),
            action_cancel: $translate.instant('action_cancel')
          }

          return dialogs
            .confirm(transl.action_deleteExclusion, msg, {
              size: 'sm',
              yes: transl.action_delete,
              no: transl.action_cancel
            })
            .result.then(function () {
              ApplicationFactory.deleteExclusion(
                exclusion.application.app_id,
                exclusion.exception_id
              ).then(
                function (response) {
                  logger.logSuccess(response.data.messages[0])
                  $scope.model.busy = true
                  clearExclusions()
                  loadExclusions(0, numPerLoad, $scope.model.row)
                },
                function (response) {
                  ErrorService.processError(response)
                }
              )
            })
        }

        function changeDefend(exclusion) {
          $scope.updating = true

          ProtectionRulesFactory.toggleDefendStatus(
            exclusion.application.app_id,
            exclusion.exception_id
          ).then(
            function () {
              $scope.updating = false
            },
            function (response) {
              $scope.updating = false
              exclusion.protection = !exclusion.protection
              ErrorService.processError(response)
            }
          )
        }

        function changeAssessment(exclusion) {
          $scope.updating = true
          ApplicationFactory.toggleAssessmentStatus(
            exclusion.application.app_id,
            exclusion.exception_id
          ).then(
            function () {
              $scope.updating = false
            },
            function (response) {
              $scope.updating = false
              exclusion.assessment = !exclusion.assessment
              ErrorService.processError(response)
            }
          )
        }

        function checkPermission(permission) {
          return isRbacEnforced()
            ? hasExclusionManagePermission()
            : permissions.hasEnterprisePermission(permission)
        }

        function checkAppRole(exclusion, role) {
          return isRbacEnforced()
            ? hasExclusionManagePermission()
            : _.includes(exclusion.application.roles, 'ROLE_' + role)
        }

        function isRbacEnforced() {
          return FeaturesService.getRbacStatus().isAssessEnforced
        }

        function hasExclusionManagePermission() {
          return permissions.hasResourcePermission(
            'EXCLUSIONS',
            'PROTECT_EXCLUSIONS_MANAGE'
          )
        }

        function getMostPermissiveRole() {
          return permissions.getMostPermissiveRole()
        }

        function getAppRole(roles) {
          return roleHelper.transformRole(roles)
        }

        init()
      }
    )
})()
